const apiV3HeadersInterceptor = async (config) => {
	config.headers['Accept'] = 'application/json, application/vnd.backlotcars.v3';
	if (!config.headers['Content-Type']) {
		config.headers['Content-Type'] = 'application/json';
	}
	return config;
};

export default apiV3HeadersInterceptor;
